module.exports = __webpack_public_path__ + "images/emoji/telephone.c48bb7af3f6afdf42dd3.png";